import React, { useState } from 'react';
import { useSpring, animated } from '@react-spring/web';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './LetsTalk.css';

const LetsTalk = () => {
  // Adjust the bounce-in animation to slow it down
  const bounceIn = useSpring({
    from: { opacity: 0, transform: 'translateY(-50px)' }, // Initial state
    to: { opacity: 1, transform: 'translateY(0px)' }, // Final state
    config: { tension: 150, friction: 25 }, // Slower settings
  });

  return (
    <div className="lets-talk-container">
      <section className="lets-talk-wrapper">
        <div className="container">
          <animated.div style={bounceIn} className="lets-talk-content">
            <div className="contact-info-container">
              <div className="contact-info">
                <h1 className="lets-talk-heading">LET'S CONNECT</h1>
                <p className="contact-email">hello@edcsquared.io</p>
                <p className="contact-description">
                  Whether you're a brand, creator, or social impact partner,
                  we'd love to hear from you. <br /> <br />
                  Reach out, and let's explore how we can create something
                  extraordinary together.
                </p>
              </div>
            </div>
            <Form />
          </animated.div>
        </div>
      </section>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

const Form = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [succeeded, setSucceeded] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);

    try {
      const response = await fetch(
        'https://eeizhsuc10.execute-api.us-east-1.amazonaws.com/live/websiteContact',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ name, email, message }),
        }
      );

      if (!response.ok) {
        throw new Error('Request failed');
      }

      toast.success('Thank you! Your message has been sent.');

      setSucceeded(true);
      setName('');
      setEmail('');
      setMessage('');
    } catch (error) {
      toast.error(
        'Sorry, there was a problem! Please contact us at hello@edcsquared.io'
      );
    } finally {
      setSubmitting(false);
    }
  };

  if (succeeded) {
    return (
      <p className="contact-description">
        Thank you! Your message has been sent.
      </p>
    );
  }

  return (
    <div className="form-content">
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <input
            className="input styled-input"
            placeholder=" "
            type="text"
            id="name"
            name="name"
            value={name}
            onChange={e => setName(e.target.value)}
            required
          />
          <label className="floating-label" htmlFor="name">
            Name
          </label>
        </div>
        <div className="form-group">
          <input
            className="input styled-input"
            placeholder=" "
            type="email"
            id="email"
            name="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
          <label className="floating-label" htmlFor="email">
            E-mail Address
          </label>
        </div>
        <div className="form-group">
          <textarea
            className="input styled-input"
            placeholder=" "
            id="message"
            name="message"
            rows="6"
            value={message}
            onChange={e => setMessage(e.target.value)}
            required
          />
          <label className="floating-label" htmlFor="message">
            Message
          </label>
        </div>
        <div className="form-button-container">
          <button className="form-button" type="submit" disabled={submitting}>
            {submitting ? (
              <span className="button-loader">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="spinner"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={{ width: '16px', height: '16px', marginRight: '8px' }}
                >
                  <circle cx="12" cy="12" r="10" className="spinner-circle" />
                  <path d="M12 2v4" />
                  <path d="M12 18v4" />
                  <path d="M4.93 4.93l2.83 2.83" />
                  <path d="M16.24 16.24l2.83 2.83" />
                  <path d="M2 12h4" />
                  <path d="M18 12h4" />
                  <path d="M4.93 19.07l2.83-2.83" />
                  <path d="M16.24 7.76l2.83-2.83" />
                </svg>
                Sending...
              </span>
            ) : (
              'SEND'
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default LetsTalk;
